// extracted by mini-css-extract-plugin
export var resizer = "_ef-0";